import { createSlice } from '@reduxjs/toolkit';

export const staticSlice = createSlice({
  name: 'static',
  initialState: {
    services: null,
    ticketTypes: null,
    noteTypes: null,
    actions: null,
    roles: null,
    users: null,
    permissions: null,
    refundStatus: null,
    orderStatus: null,
    refundTypes: null,
    refundReasons: null,
    stores: null,
    orderCancelReasons: null,
    orderRetractionReasons: null,
    savOrderReasons: null,
    paymentStatus: null,
    orderTypes: null,
    brand: null,
    contactType: null,
    currency: null,
    system: null,
    snackBar: {
      open: false,
      message: null,
      color: null,
    },
  },
  reducers: {
    setServices: (state, action) => {
      state.services = action.payload;
    },
    setTicketTypes: (state, action) => {
      state.ticketTypes = action.payload;
    },
    setNoteTypes: (state, action) => {
      state.noteTypes = action.payload;
    },
    setActions: (state, action) => {
      state.actions = action.payload;
    },
    setRoles: (state, action) => {
      state.roles = action.payload;
    },
    setUsers: (state, action) => {
      state.users = action.payload;
    },
    setPermissions: (state, action) => {
      state.permissions = action.payload;
    },
    setRefundStatus: (state, action) => {
      state.refundStatus = action.payload;
    },
    setOrderStatus: (state, action) => {
      state.orderStatus = action.payload;
    },
    setOrderTypes: (state, action) => {
      state.orderTypes = action.payload;
    },
    setBrand: (state, action) => {
      state.brand = action.payload;
    },
    setCurrency: (state, action) => {
      state.currency = action.payload;
    },
    setPaymentStatus: (state, action) => {
      state.paymentStatus = action.payload;
    },
    setRefundTypes: (state, action) => {
      state.refundTypes = action.payload;
    },
    setRefundReasons: (state, action) => {
      state.refundReasons = action.payload;
    },
    setStores: (state, action) => {
      state.stores = action.payload;
    },
    setOrderCancelReasons: (state, action) => {
      state.orderCancelReasons = action.payload;
    },
    setOrderRetractionReasons: (state, action) => {
      state.orderRetractionReasons = action.payload;
    },
    setSavOrderReasons: (state, action) => {
      state.savOrderReasons = action.payload;
    },
    setSystem: (state, action) => {
      state.system = action.payload;
    },
    setSnackBar: (state, action) => {
      state.snackBar = action.payload;
    },
    setContactTypes: (state, action) => {
      state.contactType = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  setServices,
  setTicketTypes,
  setNoteTypes,
  setActions,
  setRoles,
  setUsers,
  setPermissions,
  setContactTypes,
  setRefundStatus,
  setOrderStatus,
  setPaymentStatus,
  setRefundTypes,
  setRefundReasons,
  setStores,
  setOrderCancelReasons,
  setOrderTypes,
  setBrand,
  setCurrency,
  setOrderRetractionReasons,
  setSavOrderReasons,
  setSystem,
  setSnackBar,
} = staticSlice.actions;

export default staticSlice.reducer;
